const messages = {
  title: {
    en: 'Access Restricted',
    es: 'Acceso Restringido',
  },
  reason: {
    en: 'This restriction is in place to ensure compliance with local laws and regulations in your region.',
    es: 'Esta restricción está en vigor para garantizar el cumplimiento de las leyes y regulaciones locales en su región.',
  },
  contactInfo: {
    en: 'If you believe this is an error, please contact our support team.',
    es: 'Si cree que esto es un error, póngase en contacto con nuestro equipo de soporte.',
  },
  contactSupport: {
    en: 'Contact Support',
    es: 'Contactar Soporte',
  },
  goBack: {
    en: 'Go Back',
    es: 'Volver',
  },
  footer: {
    en: 'This restriction is temporary and may be updated based on regulatory changes.',
    es: 'Esta restricción es temporal y puede actualizarse según los cambios regulatorios.',
  },
}

export default messages
